import ScribeShapeElementModel from 'js/models/ScribeShapeElementModel';

import { getBlendModeProperties } from './renderWithBlendMode';

export const getStyleProperties = (element: ScribeShapeElementModel) => ({
  ...getBlendModeProperties(element.blendMode),
  fill: element.fill,
  opacity: element.opacity,
  backgroundType: element.backgroundType,
  backgroundColorFrom: element.backgroundColorFrom,
  backgroundColorTo: element.backgroundColorTo,
  backgroundGradientType: element.backgroundGradientType
});
